function carousel_upsell2() {
    $('.benefits-mobile').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
    });
}
function refresh_carousel() {
    $('.slick-slider').slick('refresh');
}

window.addEventListener('load', function (event) {
    carousel_upsell2();
});